import { create } from 'zustand';
import type { Me } from '../api/client';

interface PlayerState {
  me: Me | null;
  /** Auth restoration tri-state: 'pending' until the first restore attempt completes. */
  authStatus: 'pending' | 'authenticated' | 'anonymous';
  loading: boolean;
  error: string | null;
  backendAvailable: boolean | null; // null = not yet checked
  setMe: (me: Me | null) => void;
  setAuthStatus: (s: PlayerState['authStatus']) => void;
  setLoading: (l: boolean) => void;
  setError: (e: string | null) => void;
  setBackendAvailable: (v: boolean) => void;
  reset: () => void;
}

export const usePlayerStore = create<PlayerState>(set => ({
  me: null,
  authStatus: 'pending',
  loading: false,
  error: null,
  backendAvailable: null,
  setMe: (me) => set({ me, authStatus: me ? 'authenticated' : 'anonymous', loading: false, error: null }),
  setAuthStatus: (authStatus) => set({ authStatus }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error, loading: false }),
  setBackendAvailable: (v) => set({ backendAvailable: v }),
  reset: () => set({ me: null, authStatus: 'anonymous', loading: false, error: null })
}));
